export class DropdownMenuOpen {
    constructor(optionalOptions = {}) {
        this._dropdowns = document.querySelectorAll('.dropdown-menu--open');
        if (!this._dropdowns) {
            this.destructor();
            return true;
        }

        let menuId

        for (let i = 0; i < this._dropdowns.length; ++i) {
            let dropdown = this._dropdowns[i];
            dropdown.addEventListener("click", (e) => {
                e.preventDefault();

                menuId = dropdown.dataset.menu
                if (!menuId) {
                    return false
                }

                document.getElementById(menuId).classList.toggle("show");
            })
        }
    }

    destructor() {
        this._dropdowns = null;
    }
}

export default new DropdownMenuOpen();